import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css, cx, keyframes } from 'emotion';

import { baselineGrid, animation } from '../utils/presets';
import { toRem, toVW, fp } from '../utils/functions';

const { speed, curve } = animation;

const spacing = fp({
  margin: [
    `${toRem(baselineGrid * 2)} auto ${toRem(baselineGrid * 6)}`,
    `${toRem(baselineGrid * 4)} auto ${toRem(baselineGrid * 8)}`,
    `${toRem(baselineGrid * 5)} auto ${toRem(baselineGrid * 10)}`,
    `${toRem(baselineGrid * 8)} auto ${toRem(baselineGrid * 12)}`,
  ],
});

const animatedHeading = css`
  ${spacing};
  width: 80%;
  max-width: ${toRem(baselineGrid * 120)};
  font-size: calc(${toRem(baselineGrid * 3)} + ${toVW(baselineGrid * 2)});
  text-align: center;
  line-height: 1.2;
`;

const outerCell = css`
  display: inline-block;
  overflow: hidden;

  &.word {
    margin-right: -0.02em;
  }
`;

const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translate3d(0, 60%, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;

const innerCell = css`
  display: inline-block;
  animation: ${slideUp} ${speed.medium} ${curve.default} both;
`;

class AnimatedHeading extends Component {
  get chunks() {
    const splitRegex = this.props.splitRegex || this.props.splitAtWords ? new RegExp(/(\s+)/) : '';
    return this.props.text.split(splitRegex).map(chunk => chunk.replace(' ', '&nbsp;'));
  }

  render() {
    const breakLine = css`
      display: block;
      height: 0;
      margin-top: -0.125em;
      overflow: hidden;
    `;

    if (this.props.animated) {
      return (
        <h1 className={animatedHeading} aria-label={this.props.text}>
          {this.chunks.map((string, idx) => (
            <span
              key={idx}
              className={cx(
                outerCell,
                () => (this.props.splitAtWords ? 'word' : 'letter'),
                `count-${idx + 1}`,
                {
                  [breakLine]:
                    idx > 0 &&
                    (idx + 1) % (this.props.wrapWordsAfter * 2) === 0 &&
                    string === '&nbsp;',
                }
              )}
              css={css`
                span {
                  animation-delay: ${200 + 35 * idx}ms;
                }
              `}
              aria-hidden="true"
            >
              <span className={innerCell} dangerouslySetInnerHTML={{ __html: string }} />
            </span>
          ))}
        </h1>
      );
    }

    return <h1 className={animatedHeading} dangerouslySetInnerHTML={{ __html: this.props.text }} />;
  }
}

AnimatedHeading.propTypes = {
  text: PropTypes.string.isRequired,
  splitRegex: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(RegExp)])
  ),
  splitAtWords: PropTypes.bool,
  animated: PropTypes.bool,
  wrapWordsAfter: PropTypes.number,
};

AnimatedHeading.defaultProps = {
  splitAtWords: true,
  animated: true,
};

export default AnimatedHeading;



// WEBPACK FOOTER //
// ./src/components/animated-heading.js